import React from "react";
import { Outlet } from "react-router-dom";
import AccessDenied from "../Pages/AccessDenied/AccessDenied";
import Loader from "../Helpers/Loader/Loader";

interface ProtectedRouteProps {
  role: string;
  allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  role,
  allowedRoles,
}) => {

  if (!allowedRoles || allowedRoles.length == 0 || !role) {
    return (
      <>
        <Loader />
      </>
    );
  }
  else if (!allowedRoles.some((r) => String(r.value) === role)) {
    return <AccessDenied />; // or <Navigate to="/no-access" replace />
  }


  return <Outlet key={role} />; // Render nested routes
};

export default ProtectedRoute;
